// @ts-nocheck

import { navigate } from '../../../lib/routerAdapter';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input/Input';
import notification from 'antd/lib/notification';

import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Form, OrgUnitSelect, Selects } from '../../../components';
import { DatePicker } from '../../../components/ant/DatePicker';
import CancelButton from '../../../components/CancelButton';
import Breadcrumbs, { Crumb } from '../../../components/layout/Breadcrumbs';
import Header from '../../../components/layout/Header';

import { optionalEquipmentApi } from '../../../lib/api';


import { Panel, Section } from './../../../components/layout';
import Grid, { GridItem } from './../../../components/layout/Grid';
import { notificationLoading } from './../../../components/Notifications';
import { convertDateToString } from './../../../containers/Vehicles/lib';

import { withUserAccess } from './../../withUserAccess';
import { getDisabledEqipmentInstallRemoveDate } from './../lib';

const Footer = styled(Section)`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const StyledPanel = styled(Panel)`
  padding-top: 0;
`;
const Content = styled.div`
  padding: 16px;
`;

const { OptionalsTypeSelect, BrandsSelect } = Selects;








const InnerForm = ({
  onSubmit,
  onCancel,
  optionalEquipment,
  employeeOrgUnitId
}) =>
<Form onSubmit={onSubmit} initialValues={optionalEquipment}>
    {(FormField, formikProps) => {
    const {
      handleSubmit,
      handleBlur,
      setFieldValue,
      dirty,
      isSubmitting
    } = formikProps;
    return (
      <form onSubmit={handleSubmit}>
          <Section>
            <Content>
              <Grid gutter="16px">
                <GridItem>
                  <FormField
                  fast
                  label="Подразделение"
                  required
                  name="orgUnitId">

                    {({ value, name }) =>
                  <OrgUnitSelect
                    value={value || ''}
                    onChange={(orgUnitId) =>
                    setFieldValue(name, parseInt(orgUnitId, 10))
                    }
                    filter={{
                      nodeId: employeeOrgUnitId,
                      nodeFilterType: 'branchAndChildren'
                    }}
                    data-cy="orgUnitSelect" />

                  }
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField label="Наименование" required name="name" fast>
                    {(field) => <Input {...field} />}
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField
                  label="Инвентарный номер"
                  name="inventoryNumber"
                  fast>

                    {(field) => <Input {...field} />}
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField label="Тип" required name="type" fast>
                    {({ value, name }) =>
                  <OptionalsTypeSelect
                    value={value}
                    onBlur={() => handleBlur({ target: { name } })}
                    onChange={(value) => setFieldValue(name, value)}
                    data-cy="typeSelect" />

                  }
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField label="Марка" required name="brandId" fast>
                    {({ value, name }) =>
                  <BrandsSelect
                    value={value}
                    onBlur={() => handleBlur({ target: { name } })}
                    onChange={(value) => setFieldValue(name, value)}
                    data-cy="brandSelect" />

                  }
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField label="Дата выдачи" name="installDate" fast>
                    {({ name, value }) =>
                  <DatePicker
                    format="DD.MM.YYYY"
                    value={value ? moment(value) : null}
                    onChange={(value, dateString) =>
                    setFieldValue(
                      name,
                      convertDateToString(value, dateString)
                    )
                    }
                    disabledDate={getDisabledEqipmentInstallRemoveDate} />

                  }
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField label="Дата снятия" name="removeDate" fast>
                    {({ name, value }) =>
                  <DatePicker
                    format="DD.MM.YYYY"
                    value={value ? moment(value) : null}
                    onChange={(value, dateString) =>
                    setFieldValue(
                      name,
                      convertDateToString(value, dateString)
                    )
                    }
                    disabledDate={getDisabledEqipmentInstallRemoveDate} />

                  }
                  </FormField>
                </GridItem>
              </Grid>
            </Content>
          </Section>
          <Footer>
            <Button
            disabled={isSubmitting}
            loading={isSubmitting}
            type="primary"
            htmlType="submit"
            data-cy="save">

              Сохранить
            </Button>
            <CancelButton dirty={dirty} onClick={onCancel}>
              Отменить
            </CancelButton>
          </Footer>
        </form>);

  }}
  </Form>;











class OptionalForm extends Component {
  state = {};

  async componentDidMount() {
    const { optionalId } = this.props;

    if (optionalId) {
      try {
        const optionalEquipment = await optionalEquipmentApi.fetchOptionalEquipment(
          optionalId
        );
        this.setState({
          optionalEquipment
        });
      } catch (error) {
        notification.error({
          message: 'Ошибка',
          description: error.message
        });
        navigate('/equipment/optional');
      }
    }
  }

  onCancel = () => {
    if (this.props.optionalId) {
      navigate(`/equipment/optional/${this.props.optionalId}`);
    } else navigate('/equipment/optional');
  };

  onSubmit = async (optionalEquipment) => {
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      let optionalEquipmentId = optionalEquipment.id;
      if (optionalEquipment.id) {
        await optionalEquipmentApi.updateOptionalEquipment(optionalEquipment);
        notification.success({
          message: 'Успешное обновление',
          description: 'Данные были успешно обновлены'
        });
      } else {
        const addedOptionalEquipment = await optionalEquipmentApi.addOptionalEquipment(
          optionalEquipment
        );
        optionalEquipmentId = addedOptionalEquipment.id;
        notification.success({
          message: 'Успешное добавление',
          description: `Успешно добавлено доп. оборудование`
        });
      }
      navigate(`/equipment/optional/${optionalEquipmentId}`);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('saving');
    }
  };

  render() {
    const { profile } = this.props;
    const { optionalEquipment } = this.state;
    return (
      <>
        <Header
          left={
          <Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              <Crumb to="/equipment/optional">Доп. оборудование</Crumb>
              {optionalEquipment ?
            <>
                  <Crumb to={`/equipment/optional/${optionalEquipment.id}`}>
                    {optionalEquipment.brandName} {optionalEquipment.name}
                  </Crumb>
                  <Crumb>Редактирование</Crumb>
                </> :

            <Crumb>Новое доп. оборудование</Crumb>
            }
            </Breadcrumbs>
          } />

        <StyledPanel>
          <h1>
            {optionalEquipment ?
            `Дополнительное поле №${optionalEquipment.id}` :
            'Новое дополнительное оборудование'}
          </h1>
        </StyledPanel>
        <InnerForm
          optionalEquipment={
          optionalEquipment || { orgUnitId: profile.employeeOrgUnitId }
          }
          employeeOrgUnitId={profile.employeeOrgUnitId}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel} />

      </>);

  }
}

export default connect((state, props) => ({
  optionalId: parseInt(props.optionalId, 10),
  profile: state.auth.profile
}))(withUserAccess(OptionalForm));
